import { render, staticRenderFns } from "./questionNum.vue?vue&type=template&id=73445b54&scoped=true&"
import script from "./questionNum.vue?vue&type=script&lang=js&"
export * from "./questionNum.vue?vue&type=script&lang=js&"
import style0 from "./questionNum.vue?vue&type=style&index=0&id=73445b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73445b54",
  null
  
)

export default component.exports